<template>
  <div class="checklist">
    <div class="container">
      <h1>
        Заполните чек-лист
        <span class="checklist-smalltitle">Выберите нужный вариант ответа:</span>
      </h1>
      <div class="checklist-blocks">
        <div
          class="checklist-element red"
          :class="{active: active === 'yes'}"
          @click="changeCheck('yes')">   
          <span class="checklist-element__text">У меня есть симптомы вирусной инфекции</span>
        </div>
        <div
          class="checklist-element green"
          :class="{active: active === 'no'}"
          @click="changeCheck('no')">
          <span class="checklist-element__text">У меня нет симптомов вирусной инфекции </span>
        </div>
      </div>
      <div class="checklist-form" v-if="active != ''">
        <keep-alive>
          <ChecklistNoVirus v-if="active == 'no'"/>
          <ChecklistYesVirus v-if="active == 'yes'"/>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import ChecklistNoVirus from '@/components/Checklist/ChecklistNoVirus.vue'
import ChecklistYesVirus from '@/components/Checklist/ChecklistYesVirus.vue'

export default {
  components: {
    ChecklistNoVirus,
    ChecklistYesVirus
  },
  data() {
    return {
      active: ''
    }
  },
  methods: {
    changeCheck(value) {
      if (value == 'yes') {
        this.active = 'yes'
      } else {
        this.active = 'no'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checklist {
  padding: 60px 0;
  max-width: 580px;
  margin: 0 auto;
  &-smalltitle {
    display: block;
    font-size: 17px;
    font-weight: normal;
  }
  &-form {
    margin-top: 50px;
  }
  &-blocks {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 3px 8px rgba(82, 121, 146, 0.23);
    background-color: #ffffff;
    border-radius: 5px;
  }
  &-element {
    width: 50%;
    padding: 21px;
    text-align: center;
    cursor: pointer;
    transition: 0.5s;
    &:first-child {
      border-right: 1px solid #c2d5e1;
    }
    &:hover {
      box-shadow: 0 3px 6px rgba(194, 213, 225, 0.59);
    }
    &.red {
      color: #f66d6d;
      &.active {
        color: #fff;
        background: #f66d6d;
        & .checklist-element__svg path {
          stroke: #fff;
        }
        & .checklist-element__icon {
          border-color: #fff;
        }
      }
      & .checklist-element__icon {
        border: 2px solid #f66d6d;
      }
    }
    &.green {
      color: #64d282;
      &.active {
        color: #fff;
        background: #64d282;
        & .checklist-element__svg path {
          fill: #fff;
        }
        & .checklist-element__icon {
          border-color: #fff;
        }
      }
      & .checklist-element__icon {
        border: 2px solid #64d282;
      }
    }
    &__text {
      display: block;
      font-size: 20px;
      font-weight: bold;
    }
  }
}

@media screen and (max-width: 767px) {
  .checklist {
    padding: 60px 0;
    &-blocks {
      flex-wrap: wrap;
      margin-bottom: 15px;
    }
    &-element {
      width: 100%;
      display: flex;
      align-items: center;
      &:first-child {
        border-right: none;
        border-bottom: 1px solid #c2d5e1;
      }
      &__text {
        font-size: 15px;
        margin-top: 0;
      }
    }
  }
}
</style>